export const SET_HABITESE = "habitese.SET_HABITESE";
export const HABITESE_RESET = "habitese.HABITESE_RESET";
export const GET_IMPRIMIR_HABITESE = "habitese.GET_IMPRIMIR_HABITESE";
export const GET_VALIDAR_HABITESE = "habitese.GET_VALIDAR_HABITESE";
export const SET_DADOS_HABITESE = "habitese.SET_DADOS_HABITESE";
export const GET_DADOS_HABITESE = "habitese.GET_DADOS_HABITESE";

